import React from 'react';
import Icon, { IconProps } from '../Icon';

const IconZoom: React.FC<IconProps> = ({ ...props }) => {
  const fill = props.fill;
  return (
    <Icon {...props}>
      <rect width="24" height="24" rx="4" fill={fill || '#52AEFF'} />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.07537 6.75146H11.9367C13.5514 6.75146 14.6788 7.86183 14.6788 9.45309V14.029C14.6788 15.6202 13.5514 16.7306 11.9367 16.7306H8.07537C6.46069 16.7306 5.33334 15.6202 5.33334 14.029V9.45309C5.33334 7.86183 6.46069 6.75146 8.07537 6.75146ZM17.3053 8.33414C17.598 8.18555 17.9413 8.20109 18.2207 8.37669C18.5 8.55162 18.6667 8.85556 18.6667 9.18786V14.2946C18.6667 14.6276 18.5 14.9308 18.2207 15.1058C18.068 15.201 17.8973 15.2496 17.7253 15.2496C17.582 15.2496 17.4387 15.2159 17.3047 15.1476L16.3173 14.6505C15.952 14.4655 15.7253 14.094 15.7253 13.6813V9.80045C15.7253 9.3871 15.952 9.01563 16.3173 8.83192L17.3053 8.33414Z"
        fill="white"
      />
    </Icon>
  );
};

export default IconZoom;
